import { useState } from 'react';

export function useString(initialString = '') {
  const [string, setString] = useState<string>(initialString);

  const clearString = () => setString('');

  return [string, setString, clearString] as const;
}
